<template>
  <div id="google-map">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2373.0307563022457!2d18.793438216199995!3d53.50364598001237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4702ce4d21a94099%3A0xb33735f4c2f81dcf!2sDach+-+Bud!5e0!3m2!1spl!2spl!4v1560438432582!5m2!1spl!2spl"
      frameborder="0"
      style="border:0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default { name: 'GoogleMap' };
</script>

<style scoped lang="scss">
  #google-map {
    $size: calc(100vw - 30px);

    iframe {
      width: $size; height: $size;
      box-shadow: 0 0 4px rgba(0,0,0, 0.5);

      @media (min-width: 768px) {
        $size: calc(100vw - 200px);
        width: $size; height: $size;
      }
    }

    @media (min-width: 992px) {
      grid-area: maps;
      iframe { width: 100%; height: 100%; }
    }
  }
</style>
